export const achievementsPath = `/achievements`
